import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { TrackingRequest } from "src/app/model/api/api-request/tracking-request";
import { TrackingEvent } from "src/app/model/enums/tracking-event";
import { AppConfigService } from "src/app/services/app-config.service";
import { ApiClient } from "../api-client/api-client";

@Injectable({ providedIn: 'root' })
export class TrackingRepository
{
    private readonly apiClient: ApiClient;

    public constructor(apiClient: ApiClient, private environment: AppConfigService)
    {
        this.apiClient = apiClient;
    }

    public track(orderId: number, event: TrackingEvent): Observable<void>
    {
        const webapiBasepath = this.environment.config['webapibasepath'];
        return this.apiClient.put(new TrackingRequest(orderId, event, webapiBasepath));
    }
}
